import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Spinner,
  SplitButton,
  Stack,
} from '@shared/ui';
import { ChevronLeft } from 'lucide-react';

export function ButtonShowcase() {
  const { t } = useTranslation();
  const [lastAction, setLastAction] = useState('');

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.primitives.button.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.primitives.button.description')}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <Stack gap="sm">
          <SplitButton
            menuLabel={t('common.actions')}
            primaryAction={{
              id: 'save',
              label: t('common.save'),
              onSelect: () => {
                setLastAction(t('common.save'));
              },
            }}
            actions={[
              {
                id: 'edit',
                label: t('common.edit'),
                onSelect: () => {
                  setLastAction(t('common.edit'));
                },
              },
              {
                id: 'cancel',
                label: t('common.cancel'),
                onSelect: () => {
                  setLastAction(t('common.cancel'));
                },
              },
            ]}
          />
          <span role="status">{lastAction}</span>
        </Stack>
        <Stack gap="sm" className="flex-wrap">
          <Button variant="default">{t('uiLibrary.primitives.button.variants.default')}</Button>
          <Button variant="secondary">{t('uiLibrary.primitives.button.variants.secondary')}</Button>
          <Button variant="outline">{t('uiLibrary.primitives.button.variants.outline')}</Button>
          <Button variant="destructive">
            {t('uiLibrary.primitives.button.variants.destructive')}
          </Button>
          <Button variant="destructiveGhost">
            {t('uiLibrary.primitives.button.variants.destructiveGhost')}
          </Button>
          <Button variant="ghost">{t('uiLibrary.primitives.button.variants.ghost')}</Button>
          <Button variant="link">{t('uiLibrary.primitives.button.variants.link')}</Button>
        </Stack>

        <Stack gap="sm" className="flex-wrap">
          <Button size="sm">{t('uiLibrary.primitives.button.sizes.sm')}</Button>
          <Button size="default">{t('uiLibrary.primitives.button.sizes.md')}</Button>
          <Button size="lg">{t('uiLibrary.primitives.button.sizes.lg')}</Button>
        </Stack>

        <Stack gap="sm" className="flex-wrap">
          <Button disabled>{t('uiLibrary.primitives.button.states.disabled')}</Button>
          <Button disabled>
            <Spinner size="sm" className="text-primary-foreground" aria-hidden="true" />
            {t('uiLibrary.primitives.button.states.loading')}
          </Button>
          <Button
            variant="outline"
            size="sm"
            disabled
            className="min-w-[160px] justify-start text-muted-foreground"
          >
            <ChevronLeft />
            {t('uiLibrary.primitives.button.states.disabled')}
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}
